import { Dialog } from "@mui/material";
import { Box, styled } from "@mui/system";
import dangerIcon from "Assets/Icons/danger.svg";

export default function DeleteAccountModal({ open, title, body, buttons }) {
  const StyledDialog = styled(Dialog)(() => ({
    "& .MuiDialog-container": {
      background: "rgba(122, 122, 122, 0.50)",
    },

    "& .MuiDialog-paper": {
      padding: "var(--spacing-2xl)",
      maxWidth: "337px",
      borderRadius: "16px",
      boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    },
  }));

  return (
    <StyledDialog open={open}>
      {title === "Add a bank account first" && (
        <Box
          sx={{
            display: "flex",
            marginBottom: "var(-spacing-lg)",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={dangerIcon} width={80} height={80} />
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--spacing-md)",
          marginBottom: "var(--spacing-2xl)",
        }}
      >
        <Box className="header" sx={{ textAlign: "left" }}>
          {title}
        </Box>
        <Box sx={{ textAlign: "left" }}>{body}</Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--spacing-md)",
        }}
      >
        {buttons}
      </Box>
    </StyledDialog>
  );
}
